export type MemberVersion = "vip" | "svip" | "ultra";
export type MemberCycleKey = "month" | "season" | "year";
export type MemberPayMode = "subscribe" | "buyout";

export interface MemberSku {
  version: MemberVersion;
  cycle: MemberCycleKey;
  payMode: MemberPayMode;
  price: number;
  listPrice: number | null;
  credits: number;
  couponPrice: number | null;
  discountLabel: string | null;
}

/** 展示价。季付订阅按一览表 259/519。旗舰版年付售价 3599、划线 5139。券标金额走券接口，不读这里的 couponPrice。 */
export const MEMBER_SKUS: MemberSku[] = [
  sku("vip", "month", "subscribe", 87, 99, 3000, 47, "8.8折"),
  sku("vip", "month", "buyout", 99, null, 3000, 59, null),
  sku("vip", "season", "subscribe", 259, 297, 3000, 219, "8.7折"),
  sku("vip", "season", "buyout", 297, null, 3000, 257, null),
  sku("vip", "year", "subscribe", 832, 1188, 3000, null, "7折"),
  sku("vip", "year", "buyout", 1188, null, 3000, null, null),
  sku("svip", "month", "subscribe", 174, 198, 9000, 134, "8.8折"),
  sku("svip", "month", "buyout", 198, null, 9000, 158, null),
  sku("svip", "season", "subscribe", 519, 597, 9000, 479, "8.7折"),
  sku("svip", "season", "buyout", 597, null, 9000, 557, null),
  sku("svip", "year", "subscribe", 1672, 2388, 9000, null, "7折"),
  sku("svip", "year", "buyout", 2388, null, 9000, null, null),
  sku("ultra", "month", "subscribe", 339, 429, 20000, 299, "7.9折"),
  sku("ultra", "month", "buyout", 429, null, 20000, 389, null),
  sku("ultra", "season", "subscribe", 959, 1289, 20000, 919, "7.4折"),
  sku("ultra", "season", "buyout", 1289, null, 20000, 1249, null),
  sku("ultra", "year", "buyout", 3599, 5139, 20000, null, "7折")
];

function sku(
  version: MemberVersion,
  cycle: MemberCycleKey,
  payMode: MemberPayMode,
  price: number,
  listPrice: number | null,
  credits: number,
  couponPrice: number | null,
  discountLabel: string | null
): MemberSku {
  return { version, cycle, payMode, price, listPrice, credits, couponPrice, discountLabel };
}

export function findMemberSku(
  version: MemberVersion,
  cycle: MemberCycleKey,
  payMode: MemberPayMode
): MemberSku | undefined {
  return MEMBER_SKUS.find((item) => item.version === version && item.cycle === cycle && item.payMode === payMode);
}

export function supportsSubscribe(version: MemberVersion, cycle: MemberCycleKey): boolean {
  return findMemberSku(version, cycle, "subscribe") != null;
}

/** 买断不展示划线，唯一例外是 VVIP 年度买断。 */
export function shouldShowListPrice(item: MemberSku): boolean {
  if (item.listPrice == null) return false;
  return item.payMode === "subscribe" || (item.version === "ultra" && item.cycle === "year");
}

/** 买断无 KOL 券商品；连续包年已与月/季一样支持 KOL 券。 */
export function shouldHideKolCoupon(_cycle: MemberCycleKey, payMode: MemberPayMode): boolean {
  return payMode === "buyout";
}
